import { useNavigate } from "react-router-dom"
import { Button } from "src/shared/components/forms"
import CalculadoraHeader from "../calculadora/components/CalculadoraHeader/CalculadoraHeader"
import "./SuscripcionCancelada.css"

function SuscripcionCancelada() {
    const navigate = useNavigate()

    const onSubmit = () => {
        navigate("/calculadora")
    }

    return (
        <>
            <CalculadoraHeader />
            <section className="suscripcion-cancelada__screen">
                <div className="suscripcion-cancelada__content">
                    <h1 className="suscripcion-cancelada__title">
                        {"Tu suscripción está "}
                        <span>{"cancelada"}</span>
                    </h1>
                    <div className="suscripcion-cancelada__section">
                        <p className="suscripcion-cancelada__paragraph suscripcion-cancelada__paragraph-mb">
                            {"Si deseas volver a utilizar Easyroom, deberás adquirir una nueva licencia y configurar tu hotel desde cero. Tu usuario seguirá activo para recibir noticias de Easyroom y contratar una nueva licencia cuando lo desees."}
                        </p>
                        <p className="suscripcion-cancelada__paragraph">
                            {"Si necesitas recuperar la información de tu hotel, tienes "}
                            <span className="suscripcion-cancelada__paragraph-fw-600">{"60 días para ponerte en contacto"}</span>
                            {". con nosotros en "}
                            <span className="suscripcion-cancelada__paragraph-fw-500">{"info@easyroom.io. "}</span>
                            {"Una vez transcurrido este plazo, los datos se eliminarán de forma permanente y ya no podrán recuperarse."}
                        </p>
                    </div>
                    <Button onClick={onSubmit} text={"Comprar nueva licencia"} className={"suscripcion-cancelada__btn"} />
                </div>
                <div className="suscripcion-cancelada__graph">
                    <img width={"100%"} src={require("src/assets/png/suscripcion-cancelada.png")} alt={"Ssuscripción cancelada"}  />
                </div>
            </section>
        </>
    )
}

export default SuscripcionCancelada